import { action } from '@ember/object';

import type { PopupData } from 'webapp-types';

import type { Args as BaseArgs } from 'webapp/components/common/timeframe/dropdown';
import CommonTimeframeDropdownComponent from 'webapp/components/common/timeframe/dropdown';
import GoalsTimeframePopupComponent from 'webapp/components/goals/timeframe/popup';

interface Args extends BaseArgs {
	isContinuousDisabled: boolean;
	continuousDisabledTooltip?: string;
}

export default class GoalsTimeframeDropdownComponent extends CommonTimeframeDropdownComponent<Args> {
	popupExtraClass = '';

	popupComponent = GoalsTimeframePopupComponent;

	@action
	override getPopupProps(): PopupData.Goal.Timeframe {
		return {
			...super.getPopupProps(),
			isContinuousDisabled: this.args.isContinuousDisabled,
			continuousDisabledTooltip: this.args.continuousDisabledTooltip,
		};
	}
}
